import SectionTitle from '../common/SectionTitle';
import CheckListItem from '../common/CheckListItem';
const Amenities = () => {
  const clubhouseAmenities = [
    'Grand neoclassical clubhouse with elegant architectural detailing',
    'Luxurious lounges and social gathering spaces',
    'World-class fitness centre',
    'Spa and wellness facilities',
    'Exclusive restaurant and dining spaces',
    'Infinity swimming pool',
    'Landscaped terraces and serene water features',
    'Recreation, relaxation, and community interaction spaces'
  ];

  const outdoorAmenities = [
    'Landscaped gardens with flowering plants and aromatic greenery',
    'Walking areas and open leisure zones',
    'Individual parks for select villas',
    'Tree-lined avenues and scenic internal roads',
    'Festive and community-friendly environment'
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle 
          title="World-Class Amenities"
          subtitle="Everything you need for a luxurious lifestyle"
        />

        <div className="grid lg:grid-cols-2 mt-10 gap-12">
          <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-8 shadow-md hover:shadow-xl rounded-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Clubhouse & Lifestyle</h3>
            <div className="space-y-4">
              {clubhouseAmenities.map((amenity, idx) => (
                <CheckListItem key={idx} text={amenity} />
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-green-50 p-8 shadow-md hover:shadow-xl rounded-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Outdoor & Community</h3>
            <div className="space-y-4">
              {outdoorAmenities.map((amenity, idx) => (
                <CheckListItem key={idx} text={amenity} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Amenities;